<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">增加</Button>
          </Col>
          <Col span="5">
             <!--<Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>-->
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="name" label="优惠券名称" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ysl" label="已申领/申领名额" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            {{scope.row.ysl}} / {{scope.row.num}}
          </template>
        </el-table-column>

        <el-table-column prop="mz" label="抵用券面值" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="sykc" label="适用课程" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="yxq" label="有效期" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="sm" label="使用说明" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="img" label="图片" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="msg" label="操作" width="199" fixed="right">
          <template slot-scope="scope">
            <a @click="m2.sid=scope.row.id;m2.modal=true">查看申领列表</a>
            <cite>|</cite>
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="100">
				<FormItem label="优惠券名称" required>
					<Input v-model="detail.name"/>
				</FormItem>
				<FormItem label="申领名额" required>
					<Input type="number" v-model="detail.num"/>
				</FormItem>

        <FormItem label="抵用券面值" required>
          <Input  v-model="detail.mz"/>
        </FormItem>
        <FormItem label="适用课程" required>
          <Input  v-model="detail.sykc"/>
        </FormItem>
        <FormItem label="有效期" required>
          <Input  v-model="detail.yxq"/>
          <!--<DateSelect v-model="detail.yxq"></DateSelect>-->
        </FormItem>
        <FormItem label="使用说明" required>
          <Input type="textarea" v-model="detail.sm"/>
        </FormItem>
        <FormItem label="图片" required>
          <UploadOne v-model="detail.img"></UploadOne>
        </FormItem>

      </Form>
    </Modal>

    <Drawer title="申领列表" v-model="m2.modal" width="70%">
     <Slyouhui :sid="m2.sid"></Slyouhui>
    </Drawer>


  </div>
</template>

<script>
  import DateSelect from '@/public/iview/DateSelect'
  import UploadOne from '@/public/upload/UploadOne'
  import Slyouhui from './Slyouhui'
  export default {
    components:{DateSelect,UploadOne,Slyouhui},
    data(){
      return{
        baseUrl:'/api/youhui/youhui/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        m2:{
          modal:false,
          sid:0,
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.obj = null;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/youhui/Youhui.vue